import React from 'react'

import useStyles from './styles'

const NotFound = ({
  header = 'Page Not Found',
  info = 'The link you followed is no longer valid.',
  children = null
}) => {
  const classes = useStyles()

  const back = React.useCallback(() => {
    window.location.href = '/'
  }, [])

  return (
    <div className={classes.root}>
      <div className={classes.bgHolder}>
        <img src='/imgs/BG.jpg' alt='BG' className='bg' />
      </div>

      <div className={classes.box}>
        <h1 style={{ marginBottom: '4rem' }}>{header}</h1>

        <p className={classes.info}>{info}</p>

        {children ? (
          children(classes)
        ) : (
          <p className={classes.info}>
            You can{' '}
            <span className={classes.back} onClick={back}>
              return home
            </span>
          </p>
        )}
      </div>
    </div>
  )
}

export default NotFound
